const intl = require('react-intl-universal')
const { LocaleService } = require('../services/locale-service')
const { DEFAULT_LOCALE } = require('./locales')
const { enableCollection, patchIntl, setCurrentPagePath } = require('./intl-usage-collector')

module.exports = ({ element, props }) => {
  const { pageContext } = props
  let currentLocale = DEFAULT_LOCALE
  if (pageContext && pageContext.locale) currentLocale = pageContext.locale
  if (pageContext && pageContext.__intlUsagePath) {
    enableCollection()
    setCurrentPagePath(pageContext.__intlUsagePath)
  }
  patchIntl(intl)
  LocaleService.setCurrentLocale(currentLocale)
  intl.init({
    currentLocale,
    locales: {
      [currentLocale]: (pageContext && pageContext.intlMessages) || {},
    },
    warningHandler: () => {},
  })
  return element
}
